import { format, isValid, parse } from "date-fns";
import ru from "date-fns/locale/ru";

export const DATE_FORMAT = "dd.MM.yyyy";

/** "ДД.ММ.ГГГГ" → Date или null, если дата неполная / некорректная */
export const parseDate = (text) => {
  if (!text || text.length !== DATE_FORMAT.length) return null;
  const parsed = parse(text, DATE_FORMAT, new Date());
  return isValid(parsed) && parsed.getFullYear() >= 1900 ? parsed : null;
};

export const formatDate = (date) => (date ? format(date, DATE_FORMAT) : "");

export const compareDates = (a, b) => parseDate(a) - parseDate(b);

/** "31.08.2026" → "2026-08" */
export const getMonthKey = (text) => {
  const [, month, year] = text.split(".");
  return `${year}-${month}`;
};

/** "2026-08" → "Август 2026" */
export const getMonthLabel = (key) => {
  const [year, month] = key.split("-").map(Number);
  const label = format(new Date(year, month - 1, 1), "LLLL yyyy", { locale: ru });
  return label.charAt(0).toUpperCase() + label.slice(1);
};

export const formatMoney = (value) =>
  value == null ? "—" : `${Math.round(Number(value)).toLocaleString("ru-RU")} ₸`;

export const formatNumber = (value) =>
  value == null ? "—" : Math.round(Number(value)).toLocaleString("ru-RU");

/** Выручка по степени готовности: накопительно минус признанное ранее */
export const calcRevenue = (contractAmount, readiness, previous = 0) => {
  const cumulative = Math.round(((contractAmount || 0) * (readiness || 0)) / 100);
  return { cumulative, previous, current: cumulative - previous };
};

/** Последнее признание по договору */
export const getLastRecognition = (recognitions, contractId) =>
  recognitions
    .filter((item) => item.contractId === contractId)
    .sort((a, b) => compareDates(b.date, a.date))[0] || null;

/** Статус периода признания проекта относительно сегодняшней даты */
export const getSettingStatus = (setting, today = new Date()) => {
  const start = parseDate(setting.startDate);
  const end = parseDate(setting.endDate);
  if (start && today < start) return "upcoming";
  if (end && today > end) return "finished";
  return "active";
};

export const SETTING_STATUSES = {
  active: { label: "Активен", className: "is-active" },
  upcoming: { label: "Не начат", className: "is-upcoming" },
  finished: { label: "Завершён", className: "is-finished" },
};

export const PAGE_SIZE = 10;

export const getVisiblePages = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  if (current <= 3) return [1, 2, 3, "ellipsis", total];
  if (current >= total - 2) return [1, "ellipsis", total - 2, total - 1, total];
  return [1, "ellipsis", current - 1, current, current + 1, "ellipsis", total];
};
